module.exports = __webpack_public_path__ + "img/mobileBackground.ffd36093.png";